function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 10.5A2.25 2.25 0 109 6a2.25 2.25 0 000 4.5z",
  stroke: "#2C3E50",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.243 12.493l-3.183 3.182a1.5 1.5 0 01-2.12 0l-3.183-3.182a6 6 0 118.486 0v0z",
  stroke: "#2C3E50",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLocationIcon = function SvgLocationIcon(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgLocationIcon;